export default "__VITE_ASSET__DS7eK8PV__"